import React from 'react';
import { CheckCircle2, XCircle, AlertCircle, Clock } from 'lucide-react';
import { Badge } from '../ui/badge';
import { cn } from '../../lib/utils';

export const StatusBadge = ({ status, className }) => {
  const variants = {
    healthy: {
      icon: CheckCircle2,
      label: 'Healthy',
      className: 'bg-success-light text-success border-success/20',
    },
    degraded: {
      icon: AlertCircle,
      label: 'Degraded',
      className: 'bg-warning-light text-warning border-warning/20',
    },
    down: {
      icon: XCircle,
      label: 'Down',
      className: 'bg-destructive-light text-destructive border-destructive/20',
    },
    unknown: {
      icon: Clock,
      label: 'Unknown',
      className: 'bg-muted text-muted-foreground border-border',
    },
  };

  const variant = variants[status] || variants.unknown;
  const Icon = variant.icon;

  return (
    <Badge variant="outline" className={cn('gap-1.5', variant.className, className)}>
      <Icon className="h-3 w-3" />
      {variant.label}
    </Badge>
  );
};

export const CircuitBadge = ({ state, className }) => {
  const variants = {
    closed: {
      label: 'Closed',
      className: 'bg-success-light text-success border-success/20',
    },
    open: {
      label: 'Open',
      className: 'bg-destructive-light text-destructive border-destructive/20',
    },
    half_open: {
      label: 'Half-Open',
      className: 'bg-warning-light text-warning border-warning/20',
    },
  };

  const variant = variants[state] || variants.closed;

  return (
    <Badge variant="outline" className={cn('gap-1.5', variant.className, className)}>
      <div className="h-2 w-2 rounded-full bg-current" />
      {variant.label}
    </Badge>
  );
};

export const ResponseModeBadge = ({ mode, className }) => {
  const variants = {
    '200_live': {
      label: 'Live Rate',
      className: 'bg-success-light text-success border-success/20',
    },
    '200_zone': {
      label: 'Zone Fallback',
      className: 'bg-warning-light text-warning border-warning/20',
    },
    '200_country_estimate': {
      label: 'Country Estimate',
      className: 'bg-accent text-accent-foreground border-border',
    },
    '200_zone_with_hint': {
      label: 'Zone (Corrective)',
      className: 'bg-warning-light text-warning border-warning/20',
    },
    '503_arabic': {
      label: '503 Arabic',
      className: 'bg-destructive-light text-destructive border-destructive/20',
    },
    '503_catastrophic': {
      label: '503 Critical',
      className: 'bg-destructive-light text-destructive border-destructive/20',
    },
  };

  const variant = variants[mode] || variants['200_zone'];

  return (
    <Badge variant="outline" className={cn('text-xs', variant.className, className)}>
      {variant.label}
    </Badge>
  );
};
